import React from 'react';

export const TimeDisplay = ({ hh,mm,ss, type, isDanger}) => {

  if(hh===0 && mm === 0 && ss === 1)  window.location.reload();

  return (
    <div className="p-d-flex p-flex-column p-ai-center p-jc-center" >
      <p><span style={isDanger ?  {  color: "#d52b1e", fontWeight:'bold' }:{fontWeight:'bold'}}> {hh === -1 ? 0 : hh} HH : {mm === -1 ? 0 : mm} MM : {ss} SS</span></p>
    </div>
  );
};